import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import { WhatsApp as WhatsAppIcon } from "../icons";
import { Phone as PhoneIcon } from "../icons";
import { T } from "../routes/Translate";
import { normalizePhone, whatsappUrl } from "../utils/contactLinks";

// WhatsApp y "Ver teléfono" de una publicación de auto o propiedad, debajo
// del botón de chat. Solo aparece si el vendedor cargó un teléfono en la
// publicación. El número se muestra recién al tocar, y a los invitados se
// los manda a iniciar sesión (onRequireLogin) para no regalarlo a cualquier
// scraper que pase.
const ListingContactButtons = ({ phone, title, isGuest, onRequireLogin }) => {
  const [revealed, setRevealed] = useState(false);
  const number = normalizePhone(phone);
  if (!number) return null;

  const guard = (action) => (e) => {
    if (isGuest) {
      e.preventDefault();
      onRequireLogin?.();
      return;
    }
    action?.();
  };

  const message = title ? `Hola! Vi tu publicación "${title}" en Notiline.` : "Hola! Vi tu publicación en Notiline.";

  return (
    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
      <Button
        fullWidth
        variant="contained"
        startIcon={<WhatsAppIcon />}
        href={isGuest ? undefined : whatsappUrl(number, message)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={guard()}
        sx={{ textTransform: "none", fontWeight: 600, py: 1.25, bgcolor: "#25D366", color: "#fff", "&:hover": { bgcolor: "#1ebe5b" } }}
      >
        WhatsApp
      </Button>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<PhoneIcon />}
        href={revealed ? `tel:${number}` : undefined}
        onClick={revealed ? undefined : guard(() => setRevealed(true))}
        sx={{ textTransform: "none", fontWeight: 600, py: 1.25 }}
      >
        {revealed ? number : <T>Ver teléfono</T>}
      </Button>
    </Stack>
  );
};

export default ListingContactButtons;
